import axios from 'axios'
import {TokenService} from './storage.service'
import store from '../store'
import router from '../router'

const ApiService = {
  // Stores the 401 interceptor position so that it can be later ejected when needed
  _401interceptor: null,

  init(baseURL) {
    axios.defaults.baseURL = baseURL
  },

  setHeader() {
    axios.defaults.headers.common["Authorization"] = `Bearer ${TokenService.getToken()}`
  },

  removeHeader() {
    axios.defaults.headers.common = {}
  },

  get(resource) {
    return axios.get(resource)
  },

  post(resource, data) {
    return axios.post(resource, data)
  },

  put(resource, data) {
    return axios.put(resource, data)
  },

  delete(resource) {
    return axios.delete(resource)
  },

  /**
   * Perform a custom Axios request.
   *
   * data is an object containing the following properties:
   *  - method
   *  - url
   *  - data ... request payload
   *  - auth (optional)
   *    - username
   *    - password
   **/
  customRequest(data) {
    return axios(data)
  },

  putOffline(){
    store.commit('internet',false);
    router.push('/');
  },
  refresh(){
    router.go(0);
  },

  mount401Interceptor() {
    console.log('interceptor mounted')
    this._401interceptor = axios.interceptors.response.use(
      (response) => {
        return response
      },
      async (error) => {
        console.log('interceptor error catch:' + error.toString());
        //Network Error
        if(!error.request.status){
          store.commit('alert/alert_fire', {
            'title': 'Network Error',
            'message': 'Ненадеждна или липса на връзка с Интернет. Желаете ли приложението да премине в офлайн режим?',
            'callback': this.putOffline,
            'cancelCallback': this.refresh
          })
          throw error
        }

        //Unauthorised
        if (Number(error.request.status) === 401) {

          //store.dispatch('auth/logout')
          //store.commit('snack_bar/snack_bar_fire', {'message': 'Изтекла сесия или вход от друго устройство', 'type': 'error'})
          //throw error

          if (error.config.url.includes('/oauth/token')) {
              // Refresh token has failed. Logout the user
              store.dispatch('auth/logout')
              store.commit('snack_bar/snack_bar_fire', {'message': 'Изтекла сесия или вход от друго устройство', 'type': 'error'})
              throw error
          } else {
              // Refresh the access token
              try{
                  await store.dispatch('auth/refreshToken')
                  // Retry the original request
                  return this.customRequest({
                      method: error.config.method,
                      url: error.config.url,
                      data: error.config.data
                  })
              } catch (e) {
                  // Refresh has failed - reject the original request
                  throw error
              }
          }
        }

        // If error was not 401 just reject as is
        throw error
      }
    )
  },

  unmount401Interceptor() {
    // Eject the interceptor
    axios.interceptors.response.eject(this._401interceptor)
  }

}

export default ApiService
